import * as radioGroup from '@zag-js/radio-group';
import { useMachine, normalizeProps } from '@zag-js/vue';
import { useId, computed } from 'vue';
import { useEnvironmentContext } from '../../providers/environment/use-environment-context.js';
import { useLocaleContext, DEFAULT_LOCALE } from '../../providers/locale/use-locale-context.js';
import { cleanProps } from '../../utils/clean-props.js';

const useSegmentGroup = (props, emit) => {
  const id = useId();
  const env = useEnvironmentContext();
  const locale = useLocaleContext(DEFAULT_LOCALE);
  const context = computed(() => ({
    id,
    dir: locale.value.dir,
    value: props.modelValue ?? props.defaultValue,
    getRootNode: env?.value.getRootNode,
    onValueChange: (details) => {
      emit?.("valueChange", details);
      emit?.("update:modelValue", details.value);
    },
    ...cleanProps(props)
  }));
  const [state, send] = useMachine(radioGroup.machine(context.value), { context });
  return computed(() => radioGroup.connect(state.value, send, normalizeProps));
};

export { useSegmentGroup };
